// 公共
export const SupplyRouterName = {
  /** 入库单管理 */
  InboundOrder: '/supply/inventory/inbound_order/list',
  /** 新增入库单 */
  InboundOrderAdd: '/supply/inventory/inbound_order/add',
  /** 编辑入库单 */
  InboundOrderEdit: '/supply/inventory/inbound_order/edit',
  /** 入库单详情 */
  InboundOrderDetail: '/supply/inventory/inbound_order/detail',
  /** 入库单打印 */
  InboundOrderPrint: '/supply/inventory/inbound_order/print',
  /** 售后单 */
  AfterSales: '/supply/after_sales/list',
  /** 新增售后单 */
  AfterSalesCreate: '/supply/after_sales/create',
  /** 售后单详情 */
  AfterSalesDetail: '/supply/after_sales/detail',
  /**
   * 售后单编辑
   */
  AfterSalesEdit: '/supply/after_sales/edit',
  /**
   * 售后单打印
   */
  AfterSalesPrint: '/supply/after_sales/print',
  /**
   * 采购单详情
   */
  PurchaseOrderDetail: '/supply/purchase_order/detail',
  /**
   * 对账单详情
   * @param string statementNo 对账单编号
   * @description 使用方式 ${ReconciliationDetail}/${statementNo}
   * */
  StatementDetail: '/supply/bill/reconciliation/detail',
  /** 折扣定价单 */
  DiscountPriceList: '/supply/inquiry_quotation/discount_price/list',
  /** 折扣定价单详情 */
  DiscountPricesDetail: '/supply/inquiry_quotation/discount_price/detail',

  /** 商品行情价 */
  MarketPriceList: '/supply/inquiry_quotation/market_price/list',
  /** 商品行情价详情 */
  MarketPricesDetail: '/supply/inquiry_quotation/market_price/detail',
  /** 商品行情价编辑 */
  MarketPricesEdit: '/supply/inquiry_quotation/market_price/edit',
  /** 商品行情价创建 */
  MarketPricesCreate: '/supply/inquiry_quotation/market_price/create',

  /** 折扣定价单公示列表 */
  DiscountPricesPublic: '/supply/report/discount_price_public/list',
  /** 折扣定价单公示结果 */
  DiscountPricesResult: '/supply/report/discount_price_public/result',

  /** 司机绩效 */
  DriverPerformanceList: '/supply/driver_performance/list',

  /** 行车报警 */
  VehicleAlarmList: '/supply/vehicle_alarm/list',

  /** 配送任务 */
  ManageDeliveryTaskList: '/supply/delivery_task/list',

  /** 合同详情 */
  PublicPurchaserContractDetail: '/supply/report/discount_price_public/contract_detail',

  /** 现场监控 */
  LiveMonitor: '/supply/live_monitor/list',
  /** 现场监控全屏 */
  LiveMonitorFullScreen: '/supply/live_monitor/full_screen',
  /** 违规记录 */
  VolationRecordList: '/supply/live_monitor/violation_record/list',
  PurchaserContractDetail: '/supply/report/discount_price_public/contract_detail',

  /** 执行台账记录 */
  ExecutionRecordList: '/supply/execution_record/list',
  /** 执行台账记录详情 */
  ExecutionRecordDetail: '/supply/execution_record/detail',

  /** 验收标准详情 */
  AcceptanceCriteriaDetail: '/supply/acceptance_criteria/detail',

  /** 采购评价 */
  PurchaseEvaluateList: '/supply/report/purchase_evaluate/list',
  /** 采购单 */
  PurchaseOrderList: '/supply/purchase_order/list',
  /** 预警-质检报告缺失 */
  WarningQualityReportMissingList: '/supply/warning/quality_report_missing',
  /** 预警-差评采购单 */
  WarningBadReviewsPurchaseList: '/supply/warning/bad_reviews_purchase',
  /** 预警-逾期送达 */
  WarningOverdueDeliveryPurchaseList: '/supply/warning/overdue_delivery_purchase',
  /** 预警-少送错送 */
  WarningLessDeliveryPurchaseList: '/supply/warning/less_delivery_purchase',
  /** 预警-包装破损 */
  WarningDamagedPackagePurchaseList: '/supply/warning/damaged_package_purchase',
  /** 预警-温湿度不达标 */
  WarningTemperatureHumidityPurchaseList: '/supply/warning/temperature_humidity_purchase',
  /** 预警-健康证过期 */
  WarningHealthCertExpiredList: '/supply/warning/health_cert_expired',
  /** 整改记录 */
  RectificationRecordList: '/supply/rectification_record/list',
  /** 售后明细 */
  AfterSaleDetailReportList: '/supply/report/after_sale_detail_report/list',
  /** 对账明细表 */
  StatementDetailReportList: '/supply/report/statement_detail_report/list',
  /** 回单记录 */
  ReturnReceiptRecordList: '/supply/return_receipt_record/list',
  /** 采购进度 */
  PurchaseProgressList: '/supply/purchase_progress/list',
  /** 查看答卷 */
  ExaminationExamAnswerDetail: '/supply/examination/exam_answer_detail',
  /** 答题 */
  ExaminationExamAnswer: '/supply/examination/exam_answer',
  /** IO记录 */
  IoRecordList: '/supply/io_record/list',
  /** 代分拣 */
  ReplaceSortingList: '/supply/replace_sorting/list',
  /** 委外收入列表 */
  OutsourceIncomeList: '/supply/outsource/income/list',
  /** 出库单管理 */
  OutboundOrder: '/supply/inventory/outbound_order/list',
  /** 新增出库单 */
  OutboundOrderAdd: '/supply/inventory/outbound_order/add',
  /** 编辑出库单 */
  OutboundOrderEdit: '/supply/inventory/outbound_order/edit',
  /** 出库单详情 */
  OutboundOrderDetail: '/supply/inventory/outbound_order/detail',
  /** 出库单打印 */
  OutboundOrderPrint: '/supply/inventory/outbound_order/print',
  /** 仓库列表 */
  WarehouseList: '/supply/warehouse/list',
  /** 申领单管理 */
  RequisitionOrder: '/supply/inventory/requisition/list',
  /** 新增申领单 */
  RequisitionOrderAdd: '/supply/inventory/requisition/add',
  /** 编辑申领单 */
  RequisitionOrderEdit: '/supply/inventory/requisition/edit',
  /** 申领单详情 */
  RequisitionOrderDetail: '/supply/inventory/requisition/detail',
  /** 申领单完成 */
  RequisitionOrderComplete: '/supply/inventory/requisition/complete',
  /** 申领单打印 */
  RequisitionOrderPrint: '/supply/inventory/requisition/print',
  /** 盘点单管理 */
  InventorySheet: '/supply/inventory/inventory_sheet/list',
  /** 新增盘点单 */
  InventorySheetAdd: '/supply/inventory/inventory_sheet/add',
  /** 编辑盘点单 */
  InventorySheetEdit: '/supply/inventory/inventory_sheet/edit',
  /** 盘点单详情 */
  InventorySheetDetail: '/supply/inventory/inventory_sheet/detail',
  /** 盘点 */
  InventorySheetInventory: '/supply/inventory/inventory_sheet/inventory',
  /** 过账 */
  InventorySheetPosted: '/supply/inventory/inventory_sheet/posted',
  /** 物料转换单管理 */
  MaterialConversion: '/supply/inventory/material_conversion/list',
  /** 新增物料转换单 */
  MaterialConversionAdd: '/supply/inventory/material_conversion/add',
  /** 编辑物料转换单 */
  MaterialConversionEdit: '/supply/inventory/material_conversion/edit',
  /** 物料转换单详情 */
  MaterialConversionDetail: '/supply/inventory/material_conversion/detail',
  /** 批量物料转换 */
  MaterialConversionBatchAdd: '/supply/inventory/material_conversion/batch_add',
  /** 库存台账 */
  InventoryLedger: '/supply/inventory/inventory_ledger/list',
  /** 实时库存 */
  RealInventory: '/supply/inventory/real_inventory',
};
